import { z } from 'zod';

export const SenderIdentityStatusSchema = z.enum(['pending', 'approved', 'denied', 'revoked']);
export type SenderIdentityStatus = z.infer<typeof SenderIdentityStatusSchema>;

export const SenderIdentitySchema = z.object({
  boldsignIdentityId: z.string(),
  email: z.string(),
  name: z.string(),
  status: SenderIdentityStatusSchema,
  createdAt: z.string(),
  approvedAt: z.string().nullable(),
  lastCheckedAt: z.string().nullable(),
});
export type SenderIdentity = z.infer<typeof SenderIdentitySchema>;
